import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FiUser } from 'react-icons/fi';
import { Wrapper } from './styles';

const Avatar = ({
  user,
  size,
  imageUrl,
  bgColor,
  color,
  movedUp,
}) => {
  const { firstName, lastName } = user || {};

  return (
    <Wrapper
      size={size}
      firstInitial={firstName && firstName.charAt(0)}
      lastInitial={lastName && lastName.charAt(0)}
      imageUrl={imageUrl}
      bgColor={bgColor}
      color={color}
      movedUp={movedUp}
    >
      {!(firstName || lastName || imageUrl) && <FiUser />}
    </Wrapper>
  );
};

Avatar.defaultProps = {
  user: null,
  size: 'large',
  imageUrl: undefined,
  bgColor: 'var(--background-secondary-color)',
  color: 'var(--text-secondary-color)',
  movedUp: false,
};

Avatar.propTypes = {
  user: PropTypes.shape(),
  size: PropTypes.oneOf(['base', 'small', 'medium', 'large', 'extraLarge']),
  imageUrl: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  movedUp: PropTypes.bool,
};

export default memo(Avatar);
